import "./VendorCard.css";

import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Image, Button, Modal } from "react-bootstrap";
import { DatesAndGuests } from "../../widget-form/WidgetForm";
import { WidgetContext } from "../../../../../context/WidgetContext";
import ViewPort from "../../../../../_helpers/Enums/ViewPortEnum";
import LodgingItem from "../../../../../Data/LodgingItem";
import moment from "moment";
import { isStringEmpty } from "../../../../../_helpers/Functions";

interface props {
  lodging?: any;
  golf?: any;
  transport?: any;
  custom?: any;
  vendor: any;
  priceSubText?: string;
  onSelectedVendor: (vendor: any) => void;
  datesAndGuests: DatesAndGuests;
  vendorCardText?: string | undefined;
  sortedBy: number;
  simpleView: boolean;
}

const UnitTypeDialogMap: Record<string, string> = {
  "Golf": "Select Course",
  "Transportation": "Select Transportation", 
  "Lodging": "Select Lodging",
  "Custom": "Select Custom Item",
  "default": "Select A Unit Type"
}

const VendorCard: React.FC<props> = (props) => {
  const { viewPortBreakPoint, style, /* brandId */brand, brandSettings } = useContext(WidgetContext);
  const brandSetting = brandSettings.find((s: any) => s.brandId === brand?.brandId);

  const { vendor, onSelectedVendor, priceSubText, datesAndGuests, lodging, golf, transport, custom } = props;

  const [errorsImg, setErrorsImg] = useState<string | undefined>();
  const [fromPrice, setFromPrice] = useState<number>(Number.MAX_VALUE);
  const [unavailableMessages, setUnavailableMessages] = useState<string[]>(!!lodging ? getUnavailableMessages() : []);

  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";
  const vendorImageUrl = errorsImg ? errorsImg : (vendor.description ?
    (vendor.description.vendorDescriptionImages.length > 0 ?
      ((vendor.description.vendorDescriptionImages[0].vendorImageUrl != undefined && vendor.description.vendorDescriptionImages[0].vendorImageUrl.length > 0) ? vendor.description.vendorDescriptionImages[0].vendorImageUrl
        : placeholderImgUrl)
      : placeholderImgUrl)
    : placeholderImgUrl);

  function getUnavailableMessages() {
    const nights: Date[] = [];
    let night = moment(datesAndGuests.fromDate, 'YYYY-MM-DD');
    const checkOutDate = moment(datesAndGuests.toDate, 'YYYY-MM-DD');
    while (night.isBefore(checkOutDate)) {
      nights.push(night.toDate());
      night = night.clone().add(1, 'day');
    }

    const dayRates = (vendor.rates || []);
    const unavailableDates = nights.filter(night => {
      const dayRate = dayRates.find((rate: any) => moment(moment(rate.date)).isSame(night))
      return !dayRate || dayRate.unavailable
    });

    const dict: Record<string, string> = {};
    for (var i = 0; i < unavailableDates.length; i++) {
      const date = dayRates.find((rate: any) => moment(moment(rate.date)).isSame(unavailableDates[i]));

      if (date && date.unavailable) {
        dict[date.unavailableMessage || "Unavailable"] = (dict[date.unavailableMessage || "Unavailable"] || "") + moment(date.date).format('MM/DD/YYYY') + " ";
      }
      else {
        dict["Unavailable"] = (dict["Unavailable"] || "") + moment(unavailableDates[i]).format('MM/DD/YYYY') + " ";
      }
    }

    const messages = [];

    for (const key in dict) {
      const value = dict[key];

      messages.push(key + ": " + value);
    }

    return messages;
  }

  useEffect(() => {
    if (vendor) {
      setFromPrice(vendor.fromPrice);
    }
  }, [vendor]);

  return (
    <React.Fragment>
      {/* Desktop */}
      {viewPortBreakPoint >= ViewPort.lg && !props.simpleView && (
        <Row className="card-container">
          <Col xs={12}>
            <Row className="d-flex lodging-card">
              <Col xs={6}>
                <div className="w-100">
                  {!isStringEmpty(props.vendorCardText) && (
                    <p
                      className="p-1 px-3 text-center"
                      style={{
                        position: "absolute",
                        backgroundColor: "rgba(208,205,212,.75)",
                      }}
                    >
                      {props.vendorCardText}
                    </p>
                  )}
                  <Image
                    className="d-flex lodging-image"
                    src={vendorImageUrl}
                    onError={() => setErrorsImg(placeholderImgUrl)}
                    fluid
                  />
                </div>
              </Col>

              <Col className="pr-2 pb-2 d-flex flex-column justify-content-between" xs={6}>
                <h4 className="font-weight-bold text-center mt-2" style={{ color: style.fontColor }}>
                  {vendor.vendorName}
                </h4>

                {/* Feature text */}
                {vendor.description && (
                  <div className={`d-flex mt-2 feature-text pl-2`} >
                    <div>
                      <p><i className="fas fa-check" />&nbsp;&nbsp;{vendor.description.bulletPoint1}</p>
                      <p><i className="fas fa-check" />&nbsp;&nbsp;{vendor.description.bulletPoint2}</p>
                      <p><i className="fas fa-check" />&nbsp;&nbsp;{vendor.description.bulletPoint3}</p>
                    </div>
                  </div>
                )}

                {/* from price */}
                <div className="w-100 d-flex flex-column justify-content-center mb-2">
                  {fromPrice < Number.MAX_VALUE && (
                    <>
                      {vendor.rateDisplayOptions.showPkgPriceOnly && (
                        <span className="pricing-from font-weight-bold">
                          Package Price
                        </span>
                      )}
                      {!vendor.rateDisplayOptions.showPkgPriceOnly && (
                        <p className="pricing-from font-weight-bold">
                          From:{" "}
                          <span className="pricing-from-money font-weight-bold">
                            ${fromPrice.toFixed(0)}
                          </span>
                        </p>
                      )}
                    </>
                  )}
                  {/* {fromPrice == Number.MAX_VALUE && (
                    // <p className="font-italic text-center text-danger">No Rates Available</p>
                    <div>
                      {unavailableMessages.length > 0 ? unavailableMessages.map(message => {
                        return <p
                          style={{
                            fontSize: "15px",
                            color: "red",
                            textAlign: "center"
                          }}>
                          <i style={{ whiteSpace: "normal" }}>{message}</i>
                        </p>
                      }) : (
                        <p
                          style={{
                            fontSize: "15px",
                            color: "red",
                            textAlign: "center"
                          }}>
                          <i>unavailable</i>
                        </p>
                      )}
                    </div>
                  )} */}
                </div>

                {/* {fromPrice < Number.MAX_VALUE && ( */}
                {true && (
                  <Button
                    className="w-95 widget-font box-shadow m-0 p-0"
                    variant="primary"
                    block
                    size="lg"
                    style={{
                      backgroundColor: style.buttonColor,
                      // boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "4px",
                      // marginTop: "50px",
                      color: "#FFFFFF",
                      fontWeight: "bold",
                      border: "none",
                      marginBottom: "15px",
                      padding: "6px",
                    }}
                    onClick={() => onSelectedVendor(vendor)}
                  >
                    {UnitTypeDialogMap[vendor.vendorType] || UnitTypeDialogMap["default"]}
                  </Button>
                )}
              </Col>
            </Row>

          </Col>
        </Row>
      )}

      {/* Desktop Simple View */}
      {viewPortBreakPoint >= ViewPort.lg && props.simpleView && (
        <Row className="mobile-card-container">
          <Col xs={12}>

            <Row className="d-flex lodging-card">
              <Col xs={6}>
                <div className="w-100">
                  {props.vendorCardText !== undefined && (
                    <p
                      className="p-1 px-3 text-center"
                      style={{
                        position: "absolute",
                        backgroundColor: "rgba(208,205,212,.75)",
                      }}
                    >
                      {/* {vendor.features ? (typeof vendor.features.vendorCardText == undefined ? vendor.features.vendorCardText : "Card Text") : "Card Text"} */}
                      {props.vendorCardText}
                    </p>
                  )}
                  <Image
                    className="d-flex simple-lodging-image"
                    src={vendorImageUrl}
                    onError={() => setErrorsImg(placeholderImgUrl)}
                    fluid
                  />
                </div>
              </Col>

              <Col className="pr-2 pb-2 d-flex flex-column justify-content-between align-items-center" xs={6}>
                <h4 className="font-weight-bold text-center mt-2" style={{ color: style.fontColor }}>
                  {vendor.vendorName}
                </h4>

                {/* from price */}
                <div className="w-100 d-flex flex-column justify-content-center mb-1">
                  {fromPrice < Number.MAX_VALUE && (
                    <>
                      {vendor.rateDisplayOptions.showPkgPriceOnly && (
                        <span className="pricing-from font-weight-bold">
                          Package Price
                        </span>
                      )}
                      {!vendor.rateDisplayOptions.showPkgPriceOnly && (
                        <p className="pricing-from font-weight-bold">
                          From:{" "}
                          <span className="pricing-from-money font-weight-bold">
                            ${fromPrice.toFixed(0)}
                          </span>
                        </p>
                      )}
                    </>
                  )}
                  {/* {fromPrice == Number.MAX_VALUE && (
                    // <p className="font-italic text-center text-danger">No Rates Available</p>
                    <div>
                      {unavailableMessages.length > 0 ? unavailableMessages.map(message => {
                        return <p
                          style={{
                            fontSize: "15px",
                            color: "red",
                            textAlign: "center"
                          }}>
                          <i style={{ whiteSpace: "normal" }}>{message}</i>
                        </p>
                      }) : (
                        <p
                          style={{
                            fontSize: "15px",
                            color: "red",
                            textAlign: "center"
                          }}>
                          <i>unavailable</i>
                        </p>
                      )}
                    </div>
                  )} */}
                </div>

                {/* {fromPrice < Number.MAX_VALUE && ( */}
                {true && (
                  <Button
                    className="w-95 widget-font box-shadow m-0 p-0"
                    variant="primary"
                    block
                    size="lg"
                    style={{
                      backgroundColor: style.buttonColor,
                      // boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "4px",
                      // marginTop: "50px",
                      color: "#FFFFFF",
                      fontWeight: "bold",
                      border: "none",
                      marginBottom: "12px",
                      padding: "6px",
                    }}
                    onClick={() => onSelectedVendor(vendor)}
                  >
                    {UnitTypeDialogMap[vendor.vendorType] || UnitTypeDialogMap["default"]}
                  </Button>
                )}
              </Col>
            </Row>

          </Col>
        </Row>
      )}

      {/* Mobile */}
      {viewPortBreakPoint < ViewPort.lg && !props.simpleView && (
        <Row className="mobile-card-container mobile-card-border">
          <Col xs={12} className="pb-3 d-flex flex-column justify-content-between align-items-center">
            <div className="text-center">
              <h5 className="font-weight-bold text-center" style={{ color: style.fontColor, fontSize: "1.1rem" }}>
                {vendor.vendorName}
              </h5>
              {/* <p className="font-italic font weight-light" style={{ color: "grey" }}>Awesome place to be!</p> */}
            </div>

            {vendor.description && (
              <div className={`d-flex justify-content-center mt-3 feature-text`} >
                <div style={{ fontSize: "0.8rem" }}>
                  <p><i className="fas fa-check" />&nbsp;&nbsp;{vendor.description.bulletPoint1}</p>
                  <p><i className="fas fa-check" />&nbsp;&nbsp;{vendor.description.bulletPoint2}</p>
                  <p><i className="fas fa-check" />&nbsp;&nbsp;{vendor.description.bulletPoint3}</p>
                </div>
              </div>
            )}

            {/* from price */}
            <div className="w-100 d-flex flex-column justify-content-center mb-2">
              {fromPrice < Number.MAX_VALUE && (
                <>
                  {vendor.rateDisplayOptions.showPkgPriceOnly && (
                    <span className="pricing-from font-weight-bold">
                      Package Price
                    </span>
                  )}
                  {!vendor.rateDisplayOptions.showPkgPriceOnly && (
                    <p className="pricing-from font-weight-bold">
                      From:{" "}
                      <span className="pricing-from-money font-weight-bold">
                        ${fromPrice.toFixed(0)}
                      </span>
                    </p>
                  )}
                </>
              )}
              {/* {fromPrice == Number.MAX_VALUE && (
                // <p className="font-italic text-center text-danger">No Rates Available</p>
                <div>
                  {unavailableMessages.length > 0 ? unavailableMessages.map(message => {
                    return <p
                      style={{
                        fontSize: "15px",
                        color: "red",
                        textAlign: "center"
                      }}>
                      <i style={{ whiteSpace: "normal" }}>{message}</i>
                    </p>
                  }) : (
                    <p
                      style={{
                        fontSize: "15px",
                        color: "red",
                        textAlign: "center"
                      }}>
                      <i>unavailable</i>
                    </p>
                  )}
                </div>
              )} */}
            </div>

            {/* {fromPrice < Number.MAX_VALUE && ( */}
            {true && (
              <div className="w-100 px-4">
                <Button
                  className="w-100 widget-font m-0 p-0"
                  variant="primary"
                  block
                  size="lg"
                  style={{
                    backgroundColor: style.buttonColor,
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "4px",
                    // marginTop: "50px",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    border: "none",
                    marginBottom: "15px",
                    padding: "6px",
                  }}
                  onClick={() => onSelectedVendor(vendor)}
                >
                  Select
                </Button>
              </div>
            )}
          </Col>
        </Row>
      )}

      {/* Mobile Simple View */}
      {viewPortBreakPoint < ViewPort.lg && props.simpleView && (
        <Row className="simple-card-container mobile-card-border">
          <Col xs={12} className="pb-3 d-flex flex-column justify-content-between align-items-center">
            <div className="text-center">
              <h5 className="font-weight-bold text-center" style={{ color: style.fontColor, fontSize: "1.1rem" }}>
                {vendor.vendorName}
              </h5>
              {/* <p className="font-italic font weight-light" style={{ color: "grey" }}>Awesome place to be!</p> */}
            </div>

            {/* from price */}
            <div className="w-100 d-flex flex-column justify-content-center mb-2">
              {fromPrice < Number.MAX_VALUE && (
                <>
                  {vendor.rateDisplayOptions.showPkgPriceOnly && (
                    <span className="pricing-from font-weight-bold">
                      Package Price
                    </span>
                  )}
                  {!vendor.rateDisplayOptions.showPkgPriceOnly && (
                    <p className="pricing-from font-weight-bold">
                      From:{" "}
                      <span className="pricing-from-money font-weight-bold">
                        ${fromPrice.toFixed(0)}
                      </span>
                    </p>
                  )}
                </>
              )}
              {/* {fromPrice == Number.MAX_VALUE && (
                // <p className="font-italic text-center text-danger">No Rates Available</p>
                <div>
                  {unavailableMessages.length > 0 ? unavailableMessages.map(message => {
                    return <p
                      style={{
                        fontSize: "15px",
                        color: "red",
                        textAlign: "center"
                      }}>
                      <i style={{ whiteSpace: "normal" }}>{message}</i>
                    </p>
                  }) : (
                    <p
                      style={{
                        fontSize: "15px",
                        color: "red",
                        textAlign: "center"
                      }}>
                      <i>unavailable</i>
                    </p>
                  )}
                </div>
              )} */}
            </div>

            {/* {fromPrice < Number.MAX_VALUE && ( */}
            {true && (
              <div className="w-100 px-4">
                <Button
                  className="w-100 widget-font m-0 p-0"
                  variant="primary"
                  block
                  size="lg"
                  style={{
                    backgroundColor: style.buttonColor,
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "4px",
                    // marginTop: "50px",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    border: "none",
                    marginBottom: "12px",
                    padding: "6px",
                  }}
                  onClick={() => onSelectedVendor(vendor)}
                >
                  Select
                </Button>
              </div>
            )}
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
}

export default VendorCard;